export const profile = {
  'profile.theClubUserProfile.title': 'The Club User Profile',
  'profile.theClubUserProfile.userStatus': 'User Status',
  'profile.theClubUserProfile.username': 'Username',
  'profile.theClubUserProfile.memberSince': 'Member Since',
  'profile.theClubUserProfile.sponsor': 'Sponsor',
  'profile.theClubUserProfile.referralLink': 'Referral Link',
  'profile.theClubUserProfile.commissionModel': 'Commission Model',
  'profile.theClubUserProfile.commissionLevels': 'Commission Levels',
  'profile.theClubUserProfile.commissionlevel': 'Level',
  'profile.theClubUserProfile.rank': 'Rank',
  'profile.theClubUserProfile.copyTooltip': 'Copied to clipboard!',
  'profile.theClubUserProfile.copyReferralLink': 'Copy referral link',
  'profile.theClubUserProfile.userInformation': 'User Information',
  'profile.personalInformation.title': 'My Personal Information',
  'profile.personalInformation.firstName': 'First Name',
  'profile.personalInformation.lastName': 'Last Name',
  'profile.personalInformation.email': 'Email',
  'profile.personalInformation.phone': 'Phone',
  'profile.personalInformation.dateOfBirth': 'Date of Birth',
  'profile.personalInformation.gender': 'Gender',
  'profile.personalInformation.country': 'Country',
  'profile.personalInformation.address': 'Address',
  'profile.personalInformation.city': 'City',
  'profile.personalInformation.postalCode': 'Postal Code',
  'profile.personalInformation.edit': 'Edit',
  'profile.personalInformation.save': 'Save',
  'profile.personalInformation.cancel': 'Cancel',
  'profile.personalInformation.male': 'Male',
  'profile.personalInformation.female': 'Female',
  'profile.personalInformation.other': 'Other',
  'profile.personalInformation.saving': 'Saving...',
  'profile.personalInformation.selectGender': 'Select gender',
  'profile.personalInformation.saveChanges': 'Save changes',
  'profile.paymentMethods.title': 'My Payment Methods',
  'profile.paymentMethods.cryptoWallet': 'Crypto Wallet',
  'profile.paymentMethods.bankAccount': 'Bank Account',
  'profile.paymentMethods.network': 'Network',
  'profile.paymentMethods.currency': 'Currency',
  'profile.paymentMethods.address': 'Address',
  'profile.paymentMethods.accountNumber': 'Account Number',
  'profile.paymentMethods.routingNumber': 'Routing Number',
  'profile.paymentMethods.bankName': 'Bank Name',
  'profile.paymentMethods.accountHolderName': 'Account Holder Name',
  'profile.paymentMethods.swiftCode': 'SWIFT Code',
  'profile.paymentMethods.edit': 'Edit',
  'profile.paymentMethods.save': 'Save',
  'profile.paymentMethods.cancel': 'Cancel',
  'profile.paymentMethods.cryptoWalletHeader': 'Cryptocurrency Wallet',
  'profile.paymentMethods.bankAccountHeader': 'Bank Account Details',
  'profile.paymentMethods.selectNetwork': 'Select network',
  'profile.paymentMethods.selectCurrency': 'Select currency',
  'profile.paymentMethods.walletAddressPlaceholder': 'Wallet address',
  'profile.paymentMethods.accountNumberPlaceholder': 'Account number',
  'profile.paymentMethods.bankNamePlaceholder': 'Bank name',
  'profile.paymentMethods.accountHolderPlaceholder': 'Account holder name',
  'profile.paymentMethods.routingNumberPlaceholder': 'Routing number',
  'profile.paymentMethods.swiftCodePlaceholder': 'SWIFT/BIC code',
  'profile.referralLink.title': 'My Referral Link',
  'profile.referralLink.description': 'Use your referral link to invite family members, friends, and colleagues to join The Club. When they sign up using your link, you\'ll earn commissions from their profits according to your commission model.',
  'profile.referralLink.howToUse': 'How to use your referral link:',
  'profile.referralLink.step1': 'Copy your unique referral link below',
  'profile.referralLink.step2': 'Share it with people you know who are interested in investing and trading',
  'profile.referralLink.step3': 'When they register using your link, they become part of your community',
  'profile.referralLink.step4': 'Earn commissions from their profits based on your commission structure',
  'profile.referralLink.yourLink': 'Your Referral Link',
  'profile.referralLink.partnerLink': 'Partner Referral Link',
  'profile.referralLink.partnerDescription': 'Share this link with people who want to build their own referral network. They will inherit your commission plan.',
  'profile.referralLink.clientLink': 'Client Referral Link',
  'profile.referralLink.clientDescription': 'Share this link with people who want to invest only. They will not have a referral network.',
  'profile.referralLink.notAvailable': 'Referral links are not available for your account type.',
  'profile.referralLink.copyTooltip': 'Copied to clipboard!',
  'profile.referralLink.copyReferralLink': 'Copy referral link',
  'profile.referralLink.tipsForSuccessTitle': 'Tips for Success:',
  'profile.referralLink.tipsForSuccessTip1': 'Share your link with people who are genuinely interested in investing and trading',
  'profile.referralLink.tipsForSuccessTip2': 'Explain the benefits of joining The Club and how our investment programs work',
  'profile.referralLink.tipsForSuccessTip3': 'Be available to answer questions and provide support to your referrals',
  'profile.referralLink.tipsForSuccessTip4': 'Monitor your commission earnings in the "My Profits" section',
  'profile.common.loading': 'Loading...',
  'profile.common.error': 'Error loading data',
  'profile.common.noData': 'No data available',
  'profile.common.updateSuccess': 'Information updated successfully',
  'profile.common.updateError': 'Error updating information',
  'profile.common.defaultUser': 'User',
  'profile.common.defaultUsername': 'username',
  'profile.common.userMustBeActive': 'User must be active',
  'profile.errorHandling.fillRequiredFields': 'Please fill all required fields correctly',
  'profile.validation.firstName': 'First name',
  'profile.validation.lastName': 'Last name',
  'profile.validation.country': 'Country',
  'profile.validation.address': 'Address',
  'profile.validation.city': 'City',
  'profile.validation.accountNumber': 'Account number',
  'profile.validation.bankName': 'Bank name',
  'profile.validation.accountHolderName': 'Account holder name',
  'profile.validation.routingNumber': 'Routing number',
  'profile.validation.swiftCode': 'SWIFT code',
  'profile.validation.required': 'is required',
  'profile.validation.minLength': 'must be at least {count} characters',
  'profile.validation.maxLength': 'must be no more than {count} characters',  
  'profile.validation.nameFormat': 'can only contain letters, spaces, hyphens, and apostrophes',
  'profile.validation.phoneFormat': 'Please enter a valid phone number',
  'profile.validation.dateOfBirth': 'Must be a valid date and age between 18-100 years',
  'profile.validation.postalCode': 'Please enter a valid postal code',
  'profile.validation.minLengthAfterSanitization': 'must be at least {count} characters after sanitization',
  'profile.validation.selectNetwork': 'Please select a network',
  'profile.validation.selectCurrency': 'Please select a currency',
  'profile.validation.walletAddressFormat': 'Wallet address can only contain letters and numbers',
  'profile.validation.accountNumberFormat': 'Account number must contain only digits',
  'profile.validation.bankNameFormat': 'Bank name contains invalid characters',
  'profile.validation.accountHolderFormat': 'Account holder name can only contain letters, spaces, hyphens, apostrophes, and periods',
  'profile.validation.routingNumberFormat': 'Routing number must be exactly 9 digits',
  'profile.validation.swiftCodeFormat': 'Please enter a valid SWIFT/BIC code',
  'profile.toast.error': 'Error',
  'profile.toast.success': 'Success',
  'profile.toast.validationError': 'Validation Error',
};
